import { type FormEvent, useEffect, useState } from "react";
import { getSuperadminApi, getTenant, startImpersonation } from "@praesto/core";
import { signInWithImpersonationToken } from "../lib/auth-actions";
import { Modal, FormField, Input, Select, Button } from "@praesto/ui-kit";

export function ImpersonateModal(props: { tenantId: string; onClose: () => void }) {
  const [owners, setOwners] = useState<ReadonlyArray<{ id: string; email: string }>>([]);
  const [targetUid, setTargetUid] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const api = getSuperadminApi();
      const tok = await api.getAuthToken();
      const r = await getTenant(api.apiBase, props.tenantId, tok);
      if (cancelled) return;
      const owns = r.owners as Array<{ id: string; email: string }>;
      setOwners(owns);
      if (owns[0]) setTargetUid(owns[0].id);
    })().catch((e) => {
      if (!cancelled) setError(String(e));
    });
    return () => {
      cancelled = true;
    };
  }, [props.tenantId]);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const api = getSuperadminApi();
      const tok = await api.getAuthToken();
      const r = await startImpersonation(
        api.apiBase,
        {
          targetTenantId: props.tenantId,
          targetUid,
          reason,
        },
        tok,
      );
      await signInWithImpersonationToken(props.tenantId, r.customToken);
      window.location.href = `/${props.tenantId}/`;
    } catch (e2) {
      setError(String(e2));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal
      open={true}
      onClose={props.onClose}
      title={`Impersona Owner · ${props.tenantId}`}
      size="sm"
    >
      <form onSubmit={submit} className="space-y-3">
        <FormField label="Target Owner">
          <Select value={targetUid} onChange={(e) => setTargetUid(e.target.value)}>
            {owners.map((o) => (
              <option key={o.id} value={o.id}>
                {o.email}
              </option>
            ))}
          </Select>
        </FormField>
        <FormField label="Reason (es. Ticket #123) — obbligatoria">
          <Input
            value={reason}
            required
            minLength={3}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Ticket #..."
          />
        </FormField>
        <div className="flex gap-2 justify-end">
          <Button type="button" size="sm" variant="ghost" onClick={props.onClose}>
            Annulla
          </Button>
          <Button
            type="submit"
            size="sm"
            variant="primary"
            disabled={busy || !targetUid || reason.length < 3}
          >
            {busy ? "…" : "Entra come Owner"}
          </Button>
        </div>
        {error && <p className="text-sm text-danger">{error}</p>}
      </form>
    </Modal>
  );
}
